/**
 * Websocket events
 */
export const Events = {
    Get: {
        Success: 's',
        Fail: 'f',
        Progress: 'p'
    }
};
/**
 * Segment object load events
 */
export const SegmentEvent = {
    Success: 'ok',
    Fail: 'nok',
    Progress: 'pr'
};
/**
 * Loader object load events
 */
export const LoaderEvent = {
    Updated: 'updated',
    Success: 'ok',
    Fail: 'nok'
};
/**
 * Balancer API url
 */
export const Balancer = {
    host: 'gnsnpaw.com',
    devHost: 'stage-smartswitchv2.youbora.com',
    devDomains: ['stage.npaw.com', 'qa.npaw.com'],
    service: '/decision'
};
/**
 * File extensions we identify as video, excluding manifests, subtitles and audio
 */
export const VideoExtensions = ['.mp4', '.m4s', '.ts', '.cmf'];
/**
 * File extensions we identify as manifests, excluding video, subtitles and audio
 */
export const ManifestExtensions = ['.m3u8', '.mpd'];
/**
 * Peer events
 */
export const PeerEvent = {
    connect: 'connect',
    close: 'close',
    error: 'error',
    data: 'data',
    segmentError: 'segment-error',
    segmentLoaded: 'segment-loaded',
    segmentProgress: 'segment-progress',
    segmentAbsent: 'segment-absent',
    segmentRequest: 'segment-request',
    segmentTimeout: 'segment-timeout',
    dataUpdated: 'data-updated',
    bytesDownloaded: 'bytes-downloaded',
    bytesUploaded: 'bytes-uploaded',
    bytesUploadedDiscarded: 'bytes-discarded',
    ping: 'ping',
    pong: 'pong',
};
/**
 * CDN switch methods/algorithms
 */
export const SwitchMethod = {
    optimizedScore: 'optimizedScore',
    optimizedFeedback: 'optimizedFeedback',
    bestScore: 'bestScore',
    qualityPriority: 'qualityPriority',
    cdnPriority: 'cdnPriority' //Best score switching when minimum threshold is reached
};
/**
 * Limit of bits for cdn priority switching method
 */
export const CdnPriorityLimits = {
    max: 25000 * 1000,
    min: 200 * 1000,
    default: 200 * 1000 // As default value
};
/**
 * CDN fallback methods
 */
export const FallbackMethod = {
    random: 'random',
    default: 'default' // Chooses only the original or the first CDN of the list
};
/**
 * Peer commands
 */
export const PeerCommand = {
    data: 'SEGMENT_DATA',
    absent: 'SEGMENT_ABSENT',
    map: 'SEGMENTS_MAP',
    request: 'SEGMENT_REQUEST',
    cancel: 'CANCEL_SEGMENT_REQUEST',
    ping: 'PING',
    pong: 'PONG'
};
/**
 * Key names for the commands between peers
 */
export const PeerKey = {
    command: 'command',
    id: 'data_spec_key',
    size: 'size',
    map: 'keys',
    identfier: 'identifier',
    splits: 'splits',
    time: 0,
};
/**
 * Data prefixes for messages between peers
 */
export const Prefix = {
    bandwidth_test: 2,
    message: 1,
    data: 0,
};
/**
 * P2P static settings
 */
export const P2PDefaultSettings = {
    maxMessageSize: 64 * 1024 - 4,
    probability: 1,
    timeout: 2000,
    maxConcurrency: 3,
    tracker: 'wss://p2p-tracker.youbora.com/webrtc',
    upload: false
};
/**
 * Storage settings
 */
export const Storage = {
    // Expiration time of segments
    expiration: 300000,
    // Number of segments that can be stored
    count: 30,
    // Maximum number of segments that can be stored (even if the API says something different)
    safeMaxCount: 120
};
/**
 * Cdn static settings
 */
export const CDNDefaultSettings = {
    retries: 5,
    retryDelay: 100,
    defaultBwThreshold: 200000 // For CDN priority balancing method, as default value
};
/**
 * Stats calculation settings
 */
export const StatsSettings = {
    totalDataInterval: 60000 // Time in milliseconds of the requests we consider to calculate cdn/p2p recent use
};
